const styles = {
  container:
    // 'p-8 pl-4 flex-row gap-x-4 sm:gap-x-6 items-center min-w-[3rem] sm:min-w-3xs',
    '',
  image: 'w-[7rem] sm:w-[10rem] -m-3',
};

export default styles;
